import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-form-delete",
  "use": "icon-form-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-form-delete\"><path fill=\"#666666\" d=\"M800 280v624a8 8 0 0 1-8 8H232a8 8 0 0 1-8-8V280H120a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h198v-64c0-17.673 14.327-32 32-32h324c17.673 0 32 14.327 32 32v64h198a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H800z m-72 0H296v560h432V280zM408 384h48a8 8 0 0 1 8 8v384a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8V392a8 8 0 0 1 8-8z m160 0h48a8 8 0 0 1 8 8v384a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8V392a8 8 0 0 1 8-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol